//
import Model from '@/models/Model'

//
import CloseModel from '@/models/Actions/AClose'
import DispatchModel from '@/models/Actions/ADispatch'
import ReceiveModel from '@/models/Actions/AReceive'

//
export default class WhTransferBetweenWarehouse extends Model {
    /**
     *
     */
    wh_selected_products = []

    /**
     *
     */
    static includes = [
        'g_from_supervisor.hr_employee',
        'g_to_supervisor.hr_employee',
        'state',
        'wh_detail_transfer_between_warehouses.wh_product',
        'wh_from_warehouse.g_branch_office',
        'wh_to_warehouse.g_branch_office',
    ]

    /**
     *
     */
    get auth_code_length() {
        return this.auth_code_suffix.length
    }

    /**
     *
     */
    get auth_code_prefix() {
        return String('U0000000000000000').slice(0, 12 - this.auth_code_length)
    }

    /**
     *
     */
    get auth_code_simple_number() {
        return isNaN(this.auth_code_simple) ? 0 : Number(this.auth_code_simple)
    }

    /**
     *
     */
    get auth_code_suffix() {
        return String(this.auth_code_simple_number * 10)
    }

    /**
     *
     */
    get auth_code() {
        return this.auth_code_prefix.concat(this.auth_code_suffix)
    }

    /**
     *
     */
    get can_dispatch() {
        return this.can_see_dispatch && this.is_from_supervisor_user
    }

    /**
     *
     */
    get can_edit() {
        return this.state.id < 2 && this.is_to_supervisor_user
    }

    /**
     *
     */
    get can_receive() {
        return this.can_see_receive && this.is_to_supervisor_user
    }

    /**
     *
     */
    get can_see_close() {
        return this.state.id < 5
    }

    /**
     *
     */
    get can_see_dispatch() {
        return this.state.id < 2
    }

    /**
     *
     */
    get can_see_receive() {
        return this.state.id > 1 && this.state.id < 4
    }

    /**
     *
     */
    get dispatch_date_str() {
        return this.dispatch_date || '-'
    }

    /**
     *
     */
    get g_from_supervisor_full_name() {
        return [
            this.g_from_supervisor.hr_employee.names,
            this.g_from_supervisor.hr_employee.last_name1,
            this.g_from_supervisor.hr_employee.last_name2,
        ].join(' ')
    }

    /**
     *
     */
    get g_to_supervisor_full_name() {
        return this.g_to_supervisor
            ? [
                  this.g_to_supervisor.hr_employee.names,
                  this.g_to_supervisor.hr_employee.last_name1,
                  this.g_to_supervisor.hr_employee.last_name2,
              ].join(' ')
            : '-'
    }

    /**
     *
     */
    get g_state_name() {
        return this.state.state
    }

    /**
     *
     */
    get has_state() {
        return !!this.state
    }

    /**
     *
     */
    get is_auth_user() {
        return this.user ? this.user.id === this.g_to_supervisor_id : false
    }

    /**
     *
     */
    get is_from_supervisor_user() {
        return this.user ? this.user.id === this.g_from_supervisor_id : false
    }

    /**
     *
     */
    get is_to_supervisor_user() {
        return this.user ? this.user.id === this.g_to_supervisor_id : false
    }

    /**
     *
     */
    get is_not_auth_user() {
        return !this.is_auth_user
    }

    /**
     *
     */
    get wh_from_warehouse_name() {
        return this.wh_from_warehouse.name
    }

    /**
     *
     */
    get wh_to_warehouse_name() {
        return this.wh_to_warehouse.name
    }

    /**
     *
     */
    close() {
        return this.hasMany(CloseModel)
    }

    /**
     *
     */
    create() {

        // check from wharehouse stock
        this.wh_selected_products.forEach(item => {
            if (!(item.stock > 0)) {
                throw this.error('El stock de origen debe ser mayor a cero.')
            }
        })

        // set detail param
        this.details = this.wh_selected_products.map(this.mapDetail)

        // update params
        var cleans = [
            'description',
            'details',
            'g_from_supervisor_id',
            'g_to_supervisor_id',
            'wh_from_warehouse_id',
            'wh_to_warehouse_id',
        ]

        // post request
        return this.clean(cleans).save()
    }

    /**
     *
     */
    dispatch() {
        return this.hasMany(DispatchModel)
    }

    /**
     *
     */
    mapDetail(item) {
        return {
            quantity: Number(item.quantity),
            wh_product_id: Number(item.wh_product_id),
        }
    }

    /**
     *
     */
    mapDispatchDetail(item) {
        return {
            quantity_dispatch: Number(item.quantity_to_dispatch),
            wh_product_id: Number(item.wh_product_id),
        }
    }

    /**
     *
     */
    mapReceived(item) {
        return {
            received: Number(item.receive),
            state: Number(item.status_id),
            wh_product_id: Number(item.wh_product_id),
        }
    }

    /**
     *
     */
    mapSelected = () => item => {
        return {
            ...item.wh_product,
            dispatched: Number(item.dispatched || 0),
            quantity: Number(item.quantity),
            quantity_dispatch: Number(item.quantity_dispatch),
            quantity_to_dispatch: Number(item.quantity),
            receive: Number(item.quantity_dispatch - item.received),
            received: Number(item.received),
            remnant: Number(item.quantity_dispatch - item.received),
            status: item.status,
            stock: 0,
            wh_product_id: Number(item.wh_product_id),
        }
    }

    /**
     *
     */
    receive() {
        return this.hasMany(ReceiveModel).attach({
            details: this.wh_selected_products.map(this.mapReceived),
            reception_comment: this.reception_comment,
        })
    }

    /**
     *
     */
    reset({ user }) {
        //
        this.user = user
        this.wh_selected_products = this.wh_detail_transfer_between_warehouses.map(
            this.mapSelected(this)
        )

        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'wh_transfer_between_warehouse'
    }

    /**
     *
     */
    toClose() {
        //
        this.supervisor_user_code = this.auth_code_simple

        //
        return this.clean(['supervisor_user_code', 'close_comment'])
    }

    /**
     *
     */
    toDispatch() {
        //
        this.details = this.wh_selected_products.map(this.mapDispatchDetail)

        //
        return this.dispatch().attach(
            this.clean([
                'details', 
                'dispatch_comment',
                'generate_dispatch_guide',
            ])
        )
    }

    /**
     *
     */
    update() {

        // check from wharehouse stock
        //this.wh_selected_products.forEach(item => {
        //    if (!(item.stock > 0)) {
        //        throw this.error('El stock de origen debe ser mayor a cero.')
        //    }
        //})

        // set detail param
        this.details = this.wh_selected_products.map(this.mapDetail)

        // update params
        var cleans = [
            'description',
            'details',
            'g_from_supervisor_id',
            'id',
            'wh_from_warehouse_id',
            'wh_to_warehouse_id',
        ]

        // post request
        return this.clean(cleans).save()
    }
}
